import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Container, Typography, Box, Alert, Avatar} from '@mui/material';
// import {getUserProfile, register} from "../services/api";
import RegisterForm from "../components/RegisterForm";
import {UserProfile} from "../services/types";
import {fetchUserData} from "../services/api";

function getAbbreviation(str: string): string {
    const matches = str.match(/\b\w/g);
    if (!matches) return '';
    return matches.slice(0, 2).join('').toUpperCase();
}
const HeaderAvatar: React.FC = () => {
    const navigate = useNavigate();
    const [profile, setProfile] = useState<UserProfile>({
        id: 0,
        role: '',
        name: '',
        login: '',
        status: '',
        createdAt: ''
    });

    const [userName, setUserName] = useState<string>('');
    const [avatarPreview, setAvatarPreview] = useState<string | null>(null);

    useEffect(() => {
        fetchUserProfile();
    }, []);


    const fetchUserProfile = async () => {
        try {
            const data = await fetchUserData();
            setProfile(data);
            // setAvatarPreview(data.image_url);
            setUserName(getAbbreviation(data.name))
        } catch (error) {
        }
    };

    return (
        <Box className='headerAvatar' onClick={()=> navigate('/profile')} sx={{ width: 36, height: 36, fontSize: '14px', border: 'solid 2px #fff2', borderRadius: 18, textAlign: 'center', lineHeight: '36px', cursor: 'pointer' }}>
            {userName}
        </Box>
        // <Avatar className='headerAvatar' onClick={()=> navigate('/profile')} src={avatarPreview || profile.image_url} sx={{ width: 36, height: 36, border: 'solid 2px #fff' }}/>
    );
};

export default HeaderAvatar;
